import React from 'react'

export default function Text({
    content = ''
}) {
    return <span>{content}</span>
}